import React from "react";

const SidebarToggleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="sidebar_toggle_icon"
      data-name="sidebar toggle"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 5.83301L10 9.99967L5 14.1663M11 5.83301L16 9.99967L11 14.1663"
        stroke="#3A8AB9"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SidebarToggleIcon;
